module.exports = __webpack_public_path__ + "static/zenresume_background-1269a8ce2cb7e60581719f0ec118970c.png";